﻿import { ProductGridManager } from '@shared/utils/productGrid';
import { CategoryGridManager } from '@shared/utils/categoryGrid';
import { NewsGridManager } from '@shared/utils/newsGrid';

/**
 * Wires up a testimonials slider: previous/next arrows and clickable dots
 * cycle through the testimonial slides. The track is translated horizontally.
 */
function initTestimonialsSlider(container: HTMLElement): void {
    const track = container.querySelector<HTMLElement>('.testimonials-track');
    const slides = Array.from(container.querySelectorAll<HTMLElement>('.testimonial-slide'));
    const dotsContainer = container.querySelector<HTMLElement>('.testimonials-dots');
    const prevBtn = container.querySelector<HTMLElement>('.testimonials-prev');
    const nextBtn = container.querySelector<HTMLElement>('.testimonials-next');

    if (!track || slides.length === 0) return;

    let current = 0;

    // Build one dot per slide
    const dots: HTMLElement[] = [];
    if (dotsContainer) {
        slides.forEach((_, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-label', `Rezension ${index + 1}`);
            dot.className = 'h-2 rounded-full transition-all';
            dot.addEventListener('click', () => goTo(index));
            dotsContainer.appendChild(dot);
            dots.push(dot);
        });
    }

    function render(): void {
        track!.style.transform = `translateX(-${current * 100}%)`;
        dots.forEach((dot, index) => {
            const isActive = index === current;
            dot.classList.toggle('w-6', isActive);
            dot.classList.toggle('bg-company', isActive);
            dot.classList.toggle('w-2', !isActive);
            dot.classList.toggle('bg-[#cbcfd1]', !isActive);
        });
    }

    function goTo(index: number): void {
        current = (index + slides.length) % slides.length;
        render();
    }

    prevBtn?.addEventListener('click', () => goTo(current - 1));
    nextBtn?.addEventListener('click', () => goTo(current + 1));

    // Hide controls when there is only a single testimonial
    if (slides.length <= 1) {
        prevBtn?.classList.add('hidden');
        nextBtn?.classList.add('hidden');
        dotsContainer?.classList.add('hidden');
    }

    render();
}

// Initialize all product grid, category grid and news grid instances on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    const productGridContainers = document.querySelectorAll<HTMLElement>('[data-component="home-product-grid"]');
    productGridContainers.forEach(container => new ProductGridManager(container));

    const categoryGridContainers = document.querySelectorAll<HTMLElement>('[data-component="home-category-grid"]');
    categoryGridContainers.forEach(container => new CategoryGridManager(container));

    const newsGridContainers = document.querySelectorAll<HTMLElement>('[data-component="home-news-grid"]');
    newsGridContainers.forEach(container => new NewsGridManager(container));

    const testimonialSliders = document.querySelectorAll<HTMLElement>('[data-component="testimonials-slider"]');
    testimonialSliders.forEach(container => initTestimonialsSlider(container));
});
